var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.promotedResource && !_vm.loading)?_c('div',[_c('Resource',{attrs:{"title":_vm.title,"img":_vm.img,"link":_vm.link,"inSameWindow":_vm.inSameWindow,"header":_vm.headerTitle}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }